import { Reveal } from "./Reveal";
import { Globe, Megaphone, Church } from "lucide-react";
import { ArchWindow } from "./ArchWindow";

const services = [
  {
    icon: Church,
    title: "CHURCH WEBSITES",
    desc: "I start with your story: who you are, when you gather, and how a stranger can walk in on Sunday without feeling lost. Then I build a fast, mobile-first website around it, host it, and keep it running, so your congregation has a home online that costs you nothing.",
    items: ["Custom design & branding", "Sermon & event platforms", "Online giving integration", "Multilingual support"],
  },
  {
    icon: Megaphone,
    title: "GOSPEL MARKETING",
    desc: "A website nobody visits is a church with the lights off. I run the outreach that turns them on: local search so your neighbours find you, social media that carries your testimonies further than Sunday morning, and campaigns rooted in Scripture rather than gimmicks.",
    items: ["Social media strategy", "Local search visibility", "Outreach campaigns", "Testimony storytelling"],
  },
  {
    icon: Globe,
    title: "GLOBAL REACH",
    desc: "Whether your congregation meets under a tin roof or fills a thousand seats, the Gospel doesn't care about the size of the room, and neither do I. I design for your language, your culture, and your people, wherever on earth you gather.",
    items: ["Missionary support sites", "Cross-cultural design", "Translation workflows", "Training for church teams"],
  },
];

export const Services = () => (
  <section id="services" className="py-28 md:py-36 bg-[#FFF5F2] relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <div className="flex items-center gap-3">
          <ArchWindow size={14} bar="#FFF5F2" />
          <span className="font-orbitron text-xs tracking-[0.4em] text-[#E84C4C]">WHAT I BUILD</span>
        </div>
        <h2 className="font-orbitron font-bold text-2xl sm:text-3xl lg:text-4xl text-[#120716] mt-4 max-w-3xl leading-tight">
          THREE THINGS I DO FOR EVERY CHURCH THAT ASKS
        </h2>
        <p className="mt-6 max-w-2xl text-[#120716]/70 text-sm md:text-base leading-relaxed">
          I give each congregation the same care I would give a paying client, because the client here is the Kingdom.
        </p>
        <p className="mt-4 max-w-2xl italic font-light text-[#C13B3B] text-sm md:text-base">
          "How beautiful are the feet of those who preach the good news!" — Romans 10:15
        </p>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.15}>
            <div
              data-testid={`service-card-${i}`}
              className="group h-full rounded-2xl bg-white border border-[#120716]/10 shadow-sm p-8 transition-all duration-500 hover:-translate-y-2 hover:border-[#E84C4C]/40 hover:shadow-[0_20px_60px_rgba(232,76,76,0.15)]"
            >
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6" style={{ background: "linear-gradient(135deg, rgba(232,76,76,0.2), rgba(243,160,160,0.1))" }}>
                <s.icon className="w-7 h-7 text-[#E84C4C]" />
              </div>
              <h3 className="font-orbitron font-semibold text-lg text-[#120716] tracking-wider">{s.title}</h3>
              <p className="mt-4 text-sm text-[#120716]/65 leading-relaxed">{s.desc}</p>
              <ul className="mt-6 space-y-2.5">
                {s.items.map((it) => (
                  <li key={it} className="flex items-center gap-3 text-sm text-[#120716]/75">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E84C4C]" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
